import React from 'react';
import Lightbox, { type LightboxProps, type Slide } from 'yet-another-react-lightbox-lite';
import 'yet-another-react-lightbox-lite/styles.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { JucyLightBoxCaption } from './components/JucyLightBoxCaption';
import { JucyLightBoxTitle } from './components/JucyLightBoxTitle';
import { JucyLightBoxZoomButton } from './components/JucyLightBoxZoomButton';

export interface FloorplansLightBox {
    slides: LightboxProps['slides'];
    index: LightboxProps['index'];
    setIndex: LightboxProps['setIndex'];
    title?: string;
}

export const JucyLightBox: React.FC<FloorplansLightBox> = ({ slides, index, setIndex, title }) => (
    <Box
        component={Lightbox}
        slides={slides}
        index={index}
        setIndex={setIndex}
        render={{
            controls: () => <JucyLightBoxTitle title={title} />,
            slideFooter: ({ slide }: { slide: Slide }) => <JucyLightBoxCaption caption={slide?.alt} />,
            iconClose: () => <CloseIcon fontSize="inherit" className="yarll__icon" />,
            iconNext: () => <ChevronRightIcon fontSize="inherit" className="yarll__icon" />,
            iconPrev: () => <ChevronLeftIcon fontSize="inherit" className="yarll__icon" />,
        }}
        toolbar={{
            buttons: [<JucyLightBoxZoomButton key="zoom" />],
        }}
        sx={(theme) => ({
            '--yarll__backdrop_color': '#f3f9ea',
            '--yarll__navigation_button_padding': theme.spacing(0.5),
            '--yarll__button_background_color': theme.palette.background.paper,
            '--yarll__button_color': theme.palette.primary.main,
            '--yarll__button_color_active': theme.palette.primary.main,
            '--yarll__icon_size': '24px',
            '--yarll__button_filter': 'none',
            '--yarll__button_padding': theme.spacing(0.5),
            '& .yarll__toolbar': {
                display: 'flex',
                gap: 1,
            },
            '& .yarll__button': {
                opacity: 1,
                borderRadius: '50%',
                boxShadow: theme.shadows?.['2'],
                color: theme.palette.action.active,
                border: 'unset',
                transition: theme.transitions.create('boxShadow', {
                    duration: theme.transitions.duration.shortest,
                }),
                '&:hover, &:focus': {
                    background: theme.palette.common.white,
                    boxShadow: theme.shadows['3'],
                },
                '&:active': {
                    boxShadow: theme.shadows['5'],
                },
                '&:disabled': {
                    opacity: 0,
                    pointerEvents: 'none',
                },
            },
        })}
    />
);
